export function relativeTime(value: string, now = Date.now()): string {
  const minutes = Math.max(0, Math.round((now - new Date(value).getTime()) / 60_000));
  if (minutes < 60) return `${minutes}分前`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}時間前`;
  return `${Math.round(hours / 24)}日前`;
}

export function formatDuration(value: number | null): string {
  if (value === null) return "—";
  if (value < 60) return `${value}分`;
  return `${Math.floor(value / 60)}時間${value % 60 ? `${value % 60}分` : ""}`;
}
